import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Alert, CircularProgress
} from '@mui/material';
import { settlementsApi } from '../../services/api';
import GroupBalancesPanel from './GroupBalancesPanel';

// A group's balances and suggested payments, in a dialog
function GroupBalancesDialog({ open, groupId, onClose, onChanged }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!groupId) return;
    try {
      setError('');
      const response = await settlementsApi.getGroup(groupId);
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load group balances');
    }
  }, [groupId]);

  useEffect(() => {
    if (open) {
      setData(null);
      load();
    }
  }, [open, load]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{data ? `${data.group.name} balances` : 'Group balances'}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          {!data && !error && (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress />
            </Box>
          )}
          {data && <GroupBalancesPanel groupId={groupId} data={data} onData={setData} onChanged={onChanged} />}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default GroupBalancesDialog;
